export default "__VITE_ASSET__94859e6c__"